module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_13.afc879785d72a7cd0e042b7df9568ac1.png";